import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Observable, timer } from 'rxjs';
import { Store } from '@ngrx/store';
import { first, distinctUntilChanged, distinct, debounce, distinctUntilKeyChanged } from 'rxjs/operators';
import { find } from 'lodash';

import { AppState } from '../../app-reducer';
import { QuestionService } from '../../services/question.service';
import { ProcessorService } from '../../services/processor.service';

@Component({
  selector: 'vul-percentage-table',
  templateUrl: './vul-percentage-table.component.html',
  styles: ['.mat-cell {text-align: left}']
})
export class VULPercentageTableComponent implements OnInit {
  @Input() parent: FormGroup;
  @Input() childQuestions: any;
  @Input() isEditable: boolean;
  @Input() isRequired: boolean;
  blockIndex: number = 1;
  addends = new MatTableDataSource([]);
  displayedColumns: string[] = ['allocees', 'percentages'];
  maxLength: any;
  mask: any;
  tableCompound: string;
  appState$: Observable<any>;
  questions: any;
  public controls = {};
  questionNames = [];
  vulAllChildren = [];
  pvulProduct = false;

  constructor(
    private controlContainer: ControlContainer,
    public route: ActivatedRoute,
    private qs: QuestionService,
    private processorService: ProcessorService,
    private store: Store<AppState>
  ) {
    this.appState$ = this.store.select('sections');
    const sectionData = this.route.snapshot.data.blockName;
    // get questions from state
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      if (state.questions) {
        this.questions = find(state.questions, { Name: sectionData }).Questions;
        this.pvulProduct = state.content['SECTIONDCoverageDetails']['ProductName'] === "ProtectionVUL" ? true : false;
        this.qs.removeIndexedValues(this.pvulProduct);
      }
    });
  }

  ngOnInit() {

    this.maxLength = '3';
    this.mask = this.qs.activateMasks('mask-integer');

    // Analyze conditionality of table inputs
    for(let i = this.childQuestions.length - 1;i >= 0;i--) {
      const q = this.childQuestions[i];
      if ((q.ConditionalClause && !this.processorService.showConditionalQuestion(q, this.questions, this.parent.value)) || q.controlType === 'textarea') {
        this.childQuestions.splice(this.childQuestions.indexOf(q), 1);
      }
      this.tableCompound = q.ParentQuestionName;
    }

    const compounds = ['VULFundAggressiveOptionsCompound', 'VULFundGrowthOptionsCompound', 'VULFundIncomeOptionsCompound', 'VULFundGrowthIncomeOptionsCompound', 'VULFundETFOptionsCompound', 'VULFundIndexedOptionsCompound', 'VULFundLifestyleOptionsCompound', 'VULFundManagedVolatilityOptionsCompound', 'VULFundConservativeOptionsCompound'];
    this.questions.forEach(q => {
      if (compounds.includes(q.QuestionName) && this.processorService.showConditionalQuestion(q, this.questions, this.parent.value)) {
        q.ChildQuestions.map(x => Object.values(x)).forEach(k => this.vulAllChildren.push(k));
      }
    });

    this.addends.data = this.childQuestions;
    
    this.isEditable = this.isEditable == null ? true : this.isEditable;
    if (!this.isEditable) {
      this.blockIndex = -1;
    }

    this.childQuestions.forEach(child => {
      this.questionNames.push(child.QuestionName);
    });

    this.parent.valueChanges.pipe(distinctUntilChanged()).subscribe(val => {
      this.getTotal();
    });
  }

  getTotal() {
    let total = 0;

    this.questionNames.forEach(q => {
      let val = this.parent.value[q];
      if (typeof val === 'string') {       
        val = val.replace(/[\D]/gm, '');
      }
      if (!isNaN(+val)) {
        total += +val;
      }
    });
    this.qs.updateAccumulationTotal(this.tableCompound, total, this.parent, this.vulAllChildren);
  }
}
